import { render } from "./FormLIFFOption.vue?vue&type=template&id=4e5eaf6a&scoped=true"
import script from "./FormLIFFOption.vue?vue&type=script&lang=ts"
export * from "./FormLIFFOption.vue?vue&type=script&lang=ts"

import "./FormLIFFOption.vue?vue&type=style&index=0&id=4e5eaf6a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4e5eaf6a"

export default script
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QIcon,QInput,QBtn,QField});
